import { render } from "./IActionsMenu.vue?vue&type=template&id=018fa01c"
import script from "./IActionsMenu.vue?vue&type=script&lang=js"
export * from "./IActionsMenu.vue?vue&type=script&lang=js"

import "./IActionsMenu.vue?vue&type=style&index=0&id=018fa01c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__